"use client";

// Top-level error boundary. Catches errors that escape every nested boundary,
// INCLUDING failures in the root layout itself — so it must render its own
// <html>/<body> (it replaces the root layout entirely). Importing globals.css
// here keeps Tailwind/brand styles available on the fallback. This is the file
// that converts the raw "Application error: a client-side exception has
// occurred" white screen into a recoverable, logged view.
import "./globals.css";
import ErrorFallback from "@/components/shared/error-fallback";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body>
        <ErrorFallback error={error} reset={reset} />
      </body>
    </html>
  );
}
